<div class="flex flex-col min-h-screen">
  <!-- Persistent Billing Alert Banner -->
  <ng-container *ngIf="currentAlert?.hasAlert && !bannerDismissed">
    <!-- Locked Banner (Red) -->
    <div
      *ngIf="currentAlert?.isLocked"
      class="bg-red-600 text-white px-4 py-3 shadow-md flex items-center justify-between text-sm z-40 sticky top-0"
    >
      <div class="flex items-center gap-3 flex-1 min-w-0">
        <i class="fas fa-lock text-base flex-shrink-0"></i>
        <div class="truncate">
          <span class="font-bold">Group features disabled:</span>
          <span class="ml-1">
            Payment for {{ productsLabel }} is overdue. Creating and updating features is paused for all members.
          </span>
        </div>
      </div>
      <div class="flex items-center gap-3 ml-4 flex-shrink-0">
        <button
          *ngIf="isAdmin"
          type="button"
          (click)="goToBilling()"
          class="bg-white text-red-700 font-semibold px-3 py-1 rounded text-xs hover:bg-red-50 transition-colors shadow-sm"
        >
          Update Payment
        </button>
        <button
          *ngIf="!isAdmin"
          type="button"
          (click)="openDetails()"
          class="bg-red-700 hover:bg-red-800 text-white font-medium px-3 py-1 rounded text-xs transition-colors"
        >
          Details
        </button>
        <button
          type="button"
          (click)="dismissBanner()"
          class="text-red-200 hover:text-white transition-colors"
          title="Dismiss"
        >
          <i class="fas fa-xmark"></i>
        </button>
      </div>
    </div>

    <!-- Warning / Alert Popup Banner (Amber) -->
    <div
      *ngIf="!currentAlert?.isLocked"
      class="bg-amber-500 text-white px-4 py-2.5 shadow-md flex items-center justify-between text-sm z-40 sticky top-0"
    >
      <div class="flex items-center gap-3 flex-1 min-w-0">
        <i class="fas fa-triangle-exclamation text-base flex-shrink-0"></i>
        <div class="truncate">
          <span class="font-bold">Subscription payment pending:</span>
          <span class="ml-1">
            Payment for {{ productsLabel }} failed. Features will be disabled in {{ currentAlert?.daysRemaining }} day{{ currentAlert?.daysRemaining === 1 ? '' : 's' }} if unpaid.
          </span>
        </div>
      </div>
      <div class="flex items-center gap-3 ml-4 flex-shrink-0">
        <button
          *ngIf="isAdmin"
          type="button"
          (click)="goToBilling()"
          class="bg-white text-amber-800 font-semibold px-3 py-1 rounded text-xs hover:bg-amber-50 transition-colors shadow-sm"
        >
          Resolve Billing
        </button>
        <button
          *ngIf="!isAdmin"
          type="button"
          (click)="openDetails()"
          class="bg-amber-600 hover:bg-amber-700 text-white font-medium px-3 py-1 rounded text-xs transition-colors"
        >
          Info
        </button>
        <button
          type="button"
          (click)="dismissBanner()"
          class="text-amber-100 hover:text-white transition-colors"
          title="Dismiss"
        >
          <i class="fas fa-xmark"></i>
        </button>
      </div>
    </div>
  </ng-container>

  <div class="flex-1">
    <router-outlet></router-outlet>
  </div>
</div>